import Echo from "laravel-echo";

/**
 * Удаляет все специальные символы из телефонного номера, оставляя только буквы, цифры и пробелы.
 * Используется для нормализации идентификаторов чатов.
 */
export const clearChatId = (phone: string | null): string | null => {
  return typeof phone === 'string' ? phone.replace(/[^\w\s!?]/g, '') : phone;
};

/**
 * Инициализирует WebSocket-соединение через Laravel Echo на основе окружения и конфигурации.
 * Подключение активируется только в production или testing средах при наличии необходимых переменных окружения.
 *
 * @param userId — идентификатор текущего пользователя (используется в заголовках аутентификации).
 */
export const connectWebsocket = (userId: any): void => {
  // Проверяем, что Socket.IO доступен и окружение поддерживает WebSocket
  if (
      typeof window.io !== 'undefined' &&
      ['production', 'testing'].includes(process.env.REACT_APP_ENV ?? '') &&
      process.env.REACT_APP_SOCKET_HOST
  ) {
    const apiToken = localStorage.getItem('api_token');

    const headers = {
      Authorization: apiToken,
      UserId: `${process.env.REACT_APP_ENV}-${userId}`,
    };

    // Инициализация глобального экземпляра Echo
    window.Echo = new Echo({
      broadcaster: 'socket.io',
      host: `${process.env.REACT_APP_SOCKET_TLS}://${process.env.REACT_APP_SOCKET_HOST}:${process.env.REACT_APP_SOCKET_PORT}`,
      auth: { headers },
      authEndpoint: `${process.env.REACT_APP_AUTH_URL}/broadcasting/auth`,
      enabledTransports: ['ws', 'wss'],
      transports: ['websocket', 'polling', 'flashsocket'],
    });

    const socket = window.Echo?.connector?.socket;
    if (!socket) return;

    // Обработка потери соединения
    socket.on('disconnect', () => {
      console.log('Соединение с WebSocket потеряно. Попытка переподключения...');
      setTimeout(() => socket.connect(), 5000);
    });

    // Успешное восстановление соединения
    socket.on('connect', () => {
      console.log('Соединение с WebSocket восстановлено.');
    });

    // Ошибка подключения
    socket.on('connect_error', (error: unknown) => {
      console.error('Ошибка подключения к WebSocket:', error);
    });
  }
};